

export enum SimulationState {
    ABACI_TRAINING,
    SIMULATION,
    ENDED
}